/* organization/index — Organization Platform routes (Phase 2). */
import React from 'react';
import { Routes, Route, useParams, Navigate, useLocation } from 'react-router-dom';
import { usePlatformData } from '../platform/platformStore';
import { OrganizationRuntimeProvider } from './OrganizationRuntimeContext.jsx';
import OrganizationLayout from './OrganizationLayout';
import Console from './Console';
import OrgAnalytics from './OrgAnalytics';
import Workspaces from './Workspaces';
import WorkspaceDetail from './WorkspaceDetail';
import OrgMembers from './OrgMembers';
import OrgTeams from './OrgTeams';
import OrgLicenses from './OrgLicenses';
import OrgAuditLogs from './OrgAuditLogs';
import OrgTimeline from './OrgTimeline';
import Settings from './Settings';
import Branding from './Branding';
import OrgAI from './OrgAI';
import OrgChannels from './OrgChannels';
import OrgStorage from './OrgStorage';
import OrgDeveloper from './OrgDeveloper';
import OrgSupport from './OrgSupport';
import OrgHealth from './OrgHealth';
import OrgBilling from './OrgBilling';
import OrgUsage from './OrgUsage';
import OrgSearch from './OrgSearch';
import OrgBackup from './OrgBackup';
import OrgNotifications from './OrgNotifications';
import OrgIntegrations from './OrgIntegrations';
import OrgSecurityCenter from './OrgSecurityCenter';
import OrgInsights from './OrgInsights';
import OrgProfile from './OrgProfile';
import OrgIAM from './OrgIAM';

/* Preserves ?tab=... query params when redirecting legacy /roles deep links to /iam */
function RolesRedirect() {
  const { search } = useLocation();
  return <Navigate to={`../iam${search}`} replace />;
}

export default function OrganizationRoutes() {
  const { orgId } = useParams();
  const data = usePlatformData();
  return (
    <OrganizationRuntimeProvider orgId={orgId}>
    <OrganizationLayout data={data}>
      <Routes>
        <Route index                   element={<Console data={data} />} />
        <Route path="analytics"        element={<OrgAnalytics data={data} />} />
        <Route path="workspaces"       element={<Workspaces data={data} />} />
        <Route path="workspaces/:wsId" element={<WorkspaceDetail data={data} />} />
        <Route path="members"          element={<OrgMembers data={data} />} />
        <Route path="teams"            element={<OrgTeams data={data} />} />
        <Route path="roles"            element={<RolesRedirect />} />
        <Route path="iam"              element={<OrgIAM data={data} />} />
        <Route path="licenses"         element={<OrgLicenses data={data} />} />
        <Route path="audit"            element={<OrgAuditLogs data={data} />} />
        <Route path="timeline"         element={<OrgTimeline data={data} />} />
        {/* Legacy /users route — keep working */}
        <Route path="users"            element={<OrgMembers data={data} />} />
        <Route path="settings"         element={<Settings data={data} />} />
        <Route path="branding"         element={<Branding data={data} />} />
        <Route path="ai"               element={<OrgAI data={data} />} />
        <Route path="channels"         element={<OrgChannels data={data} />} />
        <Route path="storage"          element={<OrgStorage data={data} />} />
        <Route path="developer"        element={<OrgDeveloper data={data} />} />
        <Route path="support"          element={<OrgSupport data={data} />} />
        <Route path="health"           element={<OrgHealth data={data} />} />
        <Route path="billing"          element={<OrgBilling data={data} />} />
        <Route path="usage"            element={<OrgUsage data={data} />} />
        <Route path="search"           element={<OrgSearch data={data} />} />
        <Route path="backup"           element={<OrgBackup data={data} />} />
        <Route path="notifications"    element={<OrgNotifications data={data} />} />
        <Route path="integrations"     element={<OrgIntegrations data={data} />} />
        <Route path="security"         element={<OrgSecurityCenter data={data} />} />
        <Route path="templates"        element={<Navigate to="workspaces?tab=templates" replace />} />
        <Route path="insights"         element={<OrgInsights data={data} />} />
        <Route path="profile"          element={<OrgProfile data={data} />} />
      </Routes>
    </OrganizationLayout>
    </OrganizationRuntimeProvider>
  );
}
